import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { areaUnitNameConfig } from './AreaUnit.name';

enum AreaUnit {
  squareMeter = '10',
  tsubo = '11',
  hectare = '12',
}

const areaUnitMap = new Map([
  ['10', AreaUnit.squareMeter],
  ['11', AreaUnit.tsubo],
  ['12', AreaUnit.hectare],
]);

const rawValueToAreaUnit = rawValueToEnumWithDefault(areaUnitMap, '');

const areaUnitToDisplay = enumToNameWithDefault(AreaUnit, areaUnitNameConfig);

const areaUnitToDisplayWithPrefix = enumToNameWithDefault(AreaUnit, areaUnitNameConfig, true);

export { AreaUnit, areaUnitToDisplay, areaUnitToDisplayWithPrefix, rawValueToAreaUnit };
